import { render } from "./Preparation.vue?vue&type=template&id=18cbbd86"
import script from "./Preparation.vue?vue&type=script&lang=js"
export * from "./Preparation.vue?vue&type=script&lang=js"

import "./Preparation.vue?vue&type=style&index=0&id=18cbbd86&lang=less"
script.render = render

export default script